import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {khanmigoToolsDeleteFavoritedTeacherToolType} from "./__graphql-types__/index.ts";

export const DELETE_FAVORITED_TEACHER_TOOL_MUTATION: GqlOperation<
    khanmigoToolsDeleteFavoritedTeacherToolType["response"],
    khanmigoToolsDeleteFavoritedTeacherToolType["variables"]
> = gqlOp(gql`
    mutation khanmigoToolsDeleteFavoritedTeacherTool(
        $toolID: ID!
        $configName: String!
    ) {
        aiGuideDeleteFavoritedTeacherTool(
            toolID: $toolID
            configName: $configName
        ) {
            favoritedTool {
                id
                configName
            }
            error {
                code
                debugMessage
            }
        }
    }
`);
